module.exports = __webpack_public_path__ + "img/profile-driver.d10f2e2e.svg";